/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GamificationEligibilityMode } from './GamificationEligibilityMode';
import {
    GamificationEligibilityModeFromJSON,
    GamificationEligibilityModeFromJSONTyped,
    GamificationEligibilityModeToJSON,
    GamificationEligibilityModeToJSONTyped,
} from './GamificationEligibilityMode';
import type { HostRef } from './HostRef';
import {
    HostRefFromJSON,
    HostRefFromJSONTyped,
    HostRefToJSON,
    HostRefToJSONTyped,
} from './HostRef';

/**
 * Participation rules for a gamification instance
 * @export
 * @interface GamificationEligibility
 */
export interface GamificationEligibility {
    /**
     * 
     * @type {GamificationEligibilityMode}
     * @memberof GamificationEligibility
     */
    mode: GamificationEligibilityMode;
    /**
     * Required when mode = HOST_MEMBERS. Surfaces whose members may participate; membership resolves per host type.
     * @type {Array<HostRef>}
     * @memberof GamificationEligibility
     */
    hosts?: Array<HostRef>;
    /**
     * Required when mode = PREREQUISITE — must complete this model first
     * @type {string}
     * @memberof GamificationEligibility
     */
    prerequisiteModelId?: string;
    /**
     * User IDs — required when mode = INVITE_ONLY
     * @type {Array<string>}
     * @memberof GamificationEligibility
     */
    inviteList?: Array<string>;
}



/**
 * Check if a given object implements the GamificationEligibility interface.
 */
export function instanceOfGamificationEligibility(value: object): value is GamificationEligibility {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    return true;
}

export function GamificationEligibilityFromJSON(json: any): GamificationEligibility {
    return GamificationEligibilityFromJSONTyped(json, false);
}

export function GamificationEligibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationEligibility {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': GamificationEligibilityModeFromJSON(json['mode']),
        'hosts': json['hosts'] == null ? undefined : ((json['hosts'] as Array<any>).map(HostRefFromJSON)),
        'prerequisiteModelId': json['prerequisiteModelId'] == null ? undefined : json['prerequisiteModelId'],
        'inviteList': json['inviteList'] == null ? undefined : json['inviteList'],
    };
}

export function GamificationEligibilityToJSON(json: any): GamificationEligibility {
    return GamificationEligibilityToJSONTyped(json, false);
}

export function GamificationEligibilityToJSONTyped(value?: GamificationEligibility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': GamificationEligibilityModeToJSON(value['mode']),
        'hosts': value['hosts'] == null ? undefined : ((value['hosts'] as Array<any>).map(HostRefToJSON)),
        'prerequisiteModelId': value['prerequisiteModelId'],
        'inviteList': value['inviteList'],
    };
}

